export const seatMap = 
{
  0:'desk1',
  1:'desk2',
  2:'desk3',
  3:'desk4',
  4:'desk70',
  5:'desk21',
  6:'desk15',
  7:'desk22',
  8:'',
  9:'',
  10:'',
  11:'',
  12:'',
  13:'',
  14:'',
  15:'',
  16:'',
  17:'',
  18:'',
  19:'',
  20:'',
  21:'',
  22:'',
  23:'',
  24:'',
  25:'',
  26:'',
  27:'',
  28:'',
  29:'',
  30:'',
  31:'',
  32:'',
  33:'',
  34:'',
  35:'',
  36:'',
  37:'',
  38:'',
  39:'',
  40:'',
  41:'',
  42:'',
  43:'',
  44:'',
  45:'',
  46:'',
  47:'',
  48:'',
  49:''
}


// WEBPACK FOOTER //
// ./src/assets/staff_seat_map.js